import type { ReactNode } from 'react'

import { cn } from '../utilitarios/cn'

export interface ItemAba<T extends string> {
  valor: T
  rotulo: ReactNode
  /** Contador no rótulo (nº de interações, de propostas). */
  contador?: number
  desabilitada?: boolean
}

export interface PropriedadesAbas<T extends string> {
  itens: ReadonlyArray<ItemAba<T>>
  ativa: T
  onAlterar: (valor: T) => void
  className?: string
}

/** Abas do painel de histórico da TELA-05 e das telas com mais de uma visão. */
export function Abas<T extends string>({ itens, ativa, onAlterar, className }: PropriedadesAbas<T>) {
  return (
    <div
      role="tablist"
      className={cn('flex gap-1 overflow-x-auto border-b border-borda px-1', className)}
    >
      {itens.map((item) => {
        const selecionada = item.valor === ativa
        return (
          <button
            key={item.valor}
            role="tab"
            type="button"
            aria-selected={selecionada}
            disabled={item.desabilitada}
            onClick={() => onAlterar(item.valor)}
            className={cn(
              'relative -mb-px flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-t-md px-3 py-2.5 text-sm font-medium transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-marca-500/40',
              selecionada
                ? 'border-b-2 border-marca-500 text-marca-600'
                : 'border-b-2 border-transparent text-conteudo-suave hover:text-conteudo',
              item.desabilitada && 'cursor-not-allowed opacity-50',
            )}
          >
            {item.rotulo}
            {typeof item.contador === 'number' && (
              <span
                className={cn(
                  'rounded-full px-1.5 py-0.5 text-[0.6875rem] font-semibold tabular-nums',
                  selecionada ? 'bg-marca-50 text-marca-700' : 'bg-superficie-3 text-conteudo-fraco',
                )}
              >
                {item.contador}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
